
export default {
  name: 'colorMap',
  components: {},
  mixins: [],
  props: [],
  setup() {
    return {};
  },
  data() {
    return {
      colors: [],
      prefix: 'rcc-search__product__option__value-'
    };
  },
  computed: {
    dynamicColors(){
      return this.colors.map(color => `
        .${this.prefix}-${color.name} {
          background-color: ${color.hexCode} !important;
        }
      `).join('');
    }
  },
  mounted() {
    console.log('fetch colors');
    this.fetchColors();
  },
  methods: {
    // get colors
    async fetchColors() {
      try {
        const response = await axios.get('https://production-access-api.cotopaxi.com/colors/getColorsForStorefront'); 
        this.colors = response.data;
        // Wait until the entire page has loaded before injecting the styles
        window.onload = () => {
          this.injectStyles();
        };
      } catch (error) {
        console.error('Error fetching colors:', error);
      }
    },
    //inject them as styles
    injectStyles() {
      const style = document.createElement('style');
      style.type = 'text/css';
      // Map over each color
      style.innerHTML = this.colors.map(color => {
        // Get the associated variant names and parse them
        const variantNames = this.parseVariantNames(color.associatedVariantNames);

        // Generate styles for each variant in camelCase, snake_case, and lowercase without spaces
        return variantNames.map(variant => `
          .${this.prefix}-${this.convertToCamelCase(variant)},
          .${this.prefix}-${this.convertToSnakeCase(variant)} ,
          .${this.prefix}-${this.convertToLowerCaseNoSpaces(variant)} {
            background-color: ${color.hexCode} !important;
          }
        `).join('');
      }).join('');
      document.head.appendChild(style);
    },
    // Parse associatedVariantNames into an array by splitting on commas
    parseVariantNames(variantNames) {
      return variantNames.split(',').map(name => name.trim());
    },
    convertToCamelCase(name) {
      // Replace slashes and apostrophes with spaces, and apply camelCase transformation
      return name
        .replace(/[\/']+/g, ' ')  // Replace slashes and apostrophes with spaces
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => index === 0 ? match.toLowerCase() : match.toUpperCase())
        .replace(/\s+/g, '');  // Remove spaces
    },

    convertToSnakeCase(name) {
      // Replace slashes and apostrophes with underscores and convert to snake_case
      return name.toLowerCase().replace(/[\/'\s]+/g, '_');  // Handle slashes, apostrophes, and spaces
    },

    convertToLowerCaseNoSpaces(name) {
      // Replace slashes, apostrophes, and spaces, then convert to all lowercase without spaces
      return name.toLowerCase().replace(/[\/'\s]+/g, '');  // Handle slashes, apostrophes, and spaces
    }
  }
};